
<div style="height: 140px;">
    <div class="w-100 step-title v-flex" >
        <div
            class = "primary--text"
            style = "margin-bottom: 0; padding-top:  16px;"
        >
            {{ $t('contract.payment.title') }}
        </div>
        <v-checkbox
            v-model   = "contract.invoiceInAdvance"
            label     = "im Voraus"
            :ripple   = "false"
            :readonly = "true"
            style     = "margin-top: 11px"
            hide-details
        />
    </div>
    <v-row class="no-frame">
        <v-col class="no-frame pr-2 col-7">
            <f-read-only-field
                v-if="contract.invoiceFrequency"
                class  = "w-100 mt-1"
                :dense = "true"
                label  = "Frequenz"
                :value = "contract.invoiceFrequency ? contract.invoiceFrequency.name : null"
                color  = "pt-0-5 pl-1 ro-background"
            />
        </v-col>
        <v-col class="no-frame pl-2">
            <v-row class="no-frame"  >
                <v-col class="col-3 no-frame pr-2">
                    <f-read-only-field
                        v-if   = "contract.invoiceFrequency && contract.invoiceFrequency.id !== 1"
                        class  = "w-100 mt-1"
                        :dense = "true"
                        label  = "Tag"
                        :value = "contract.invoiceDay"
                        color  = "pt-0-5 pl-1 ro-background"
                    />
                </v-col>
                <v-col class="col-9 no-frame pl-2">
                    <f-read-only-field
                        v-if   = "contract.invoiceFrequency && contract.invoiceFrequency.id !== 2 && contract.invoiceFrequency.id !== 1"
                        class  = "w-100 mt-1"
                        :dense = "true"
                        label  = "Monat"
                        :value = "contract.invoiceMonth ? contract.invoiceMonth : null"
                        color  = "pt-0-5 pl-1 ro-background"
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    <v-row class="no-frame mt-2" v-if="contract.invoiceFrequency && contract.invoiceFrequency.id !== 1 && contract.invoiceFrequency.id !== 2">
        <f-read-only-field
            class  = "w-100"
            label  = "Termine"
            :value = "deadline"
            color  = "pt-0-5 pl-1 ro-background"
        />
    </v-row>
</div>
